import React from "react";
export function SiteStatement() {
  return <div className="bg-ink text-white" data-id="element-241" data-mp="17wky6u5zoh2h">
      <div className="page-container" data-id="element-242" data-mp="2au9x9oys2xpo">
        <p className="py-2.5 text-center text-label font-semibold" data-id="element-243" data-mp="2asfeag72hfo8">
          Michigan motorcycle accident lawyers for injured riders and families.
        </p>
      </div>
    </div>;
}